import React from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, subtitle, actions, children, className }) => (
  <section className={`mc-card${className ? ` ${className}` : ''}`}>
    {(title || actions) && (
      <div className='mc-card__header'>
        <div>
          {title && <h2>{title}</h2>}
          {subtitle && <p>{subtitle}</p>}
        </div>
        {actions}
      </div>
    )}
    {children}
  </section>
);

export default Card;
